<template>
  <div>
    <h1 class="mb-8 font-bold text-2xl">LISTE DE POSTES EXPEDIÉ</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null"/>
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <div class="flex">
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-2 pt-6 pb-4">N° Order</th>
          <th class="px-2 pt-6 pb-4">IMEI</th>
          <th class="px-6 pt-6 pb-4">Brand</th>
          <th class="px-6 pt-6 pb-4">Model</th>
          <th class="px-6 pt-6 pb-4">Panne</th>
          <th class="px-6 pt-6 pb-4">Commentaire</th>
          <th class="px-6 pt-6 pb-4">Accusé envoi par</th>
          <th class="px-6 pt-6 pb-4">Date reception</th>
          <th class="px-6 pt-6 pb-4">Bordereaux d'expedition</th>
          <th class="px-6 pt-6 pb-4">Annuler</th>
        </tr>
        <tr v-for="repair in repairs.data" :key="repair.id" class="hover:bg-gray-100" :class="status(repair)">
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-indigo-500" >
              {{ repair.id }}
              <icon v-if="repair.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center"
                          tabindex="-1">
              {{ repair.imei }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center"
                          tabindex="-1">
              {{ repair.brand }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center"
                          tabindex="-1">
              {{ repair.model}}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center"
                          tabindex="-1">
              {{ repair.malfunction}}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center"
                          tabindex="-1">
              {{ repair.comment}}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center"
                  tabindex="-1">
              {{ repair.accused_shipment }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center" :title="repair.creation_date"
                          tabindex="-1">
              {{ repair.created_at }}
            </span>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="Imprimer le Bordereaux D'expedition" @click="printInvoice(repair.id)">
              <svg class="h-10 w-10 mx-auto text-green-600 hover:text-green-800" xmlns="http://www.w3.org/2000/svg" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
              </svg>
            </span>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="Annuler" @click="cancelTest(repair.id)">
              <svg  class="h-10 w-10 mx-auto text-red-600 hover:text-green-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </span>
          </td>
        </tr>
        <tr v-if="repairs.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No reparation found.</td>
        </tr>
      </table>
    </div>
    <pagination :links="repairs.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import JetDangerButton from '@/Jetstream/DangerButton'


export default {
  metaInfo: {title: 'Postes expedié'},
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
    JetDangerButton,
  },
  props: {
    repairs: Object,
    filters: Object,
  },
  data() {
    return {
      selected: [],
      selectAll: false,
      sending: false,
      form: {},
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('test.sent', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    select() {
      this.selected = [];
      if (this.selectAll) {
        for (let i in this.repairs.data) {
          if (this.repairs.data.hasOwnProperty(i)) {
            this.selected.push(this.repairs.data[i].id);
          }
        }
      }
    },
    printInvoice(id) {
      window.open(this.route('test.generateSlip', id), "_blank");
    },
    cancelTest(id) {
      const data = new FormData()
      data.append('id', id || "")
      this.$inertia.post(this.route('test.cancel'), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => {
          this.sending = false
        }
      })
    },

    status(repair) {
      if (repair.repaired) {
        return 'bg-green-300'
      } else if (repair.irreparable) {
        return 'bg-red-300'
      } else if (repair.quote_rejected) {
        return 'bg-yellow-800'
      } else if (repair.quote_accepted) {
        return 'bg-orange-500'
      }
    }
  },
}
</script>
